"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchMethod = exports.ComponentType = exports.OutgoingBatchEventResult = exports.OutgoingBatchState = exports.IncomingBatchEventResult = exports.IncomingBatchState = exports.DispatchState = void 0;
var DispatchState;
(function (DispatchState) {
    DispatchState["CREATED"] = "CREATED";
    DispatchState["SENT"] = "SENT";
    DispatchState["DELIVERED"] = "DELIVERED";
})(DispatchState = exports.DispatchState || (exports.DispatchState = {}));
var IncomingBatchState;
(function (IncomingBatchState) {
    IncomingBatchState["RECEIVED"] = "RECEIVED";
    IncomingBatchState["PROCESSED"] = "PROCESSED";
    IncomingBatchState["ERROR"] = "ERROR";
    IncomingBatchState["REPLACED"] = "REPLACED";
})(IncomingBatchState = exports.IncomingBatchState || (exports.IncomingBatchState = {}));
var IncomingBatchEventResult;
(function (IncomingBatchEventResult) {
    IncomingBatchEventResult["PROCESSED"] = "PROCESSED";
    IncomingBatchEventResult["ERROR"] = "ERROR";
})(IncomingBatchEventResult = exports.IncomingBatchEventResult || (exports.IncomingBatchEventResult = {}));
var OutgoingBatchState;
(function (OutgoingBatchState) {
    OutgoingBatchState["ENQUEUED"] = "ENQUEUED";
    OutgoingBatchState["SENT"] = "SENT";
    OutgoingBatchState["PROCESSED"] = "PROCESSED";
    OutgoingBatchState["ERROR"] = "ERROR";
    OutgoingBatchState["REPLACED"] = "REPLACED";
})(OutgoingBatchState = exports.OutgoingBatchState || (exports.OutgoingBatchState = {}));
var OutgoingBatchEventResult;
(function (OutgoingBatchEventResult) {
    OutgoingBatchEventResult["PROCESSED"] = "PROCESSED";
    OutgoingBatchEventResult["ERROR"] = "ERROR";
})(OutgoingBatchEventResult = exports.OutgoingBatchEventResult || (exports.OutgoingBatchEventResult = {}));
/**
 * Typ komponenty
 */
var ComponentType;
(function (ComponentType) {
    ComponentType["MAIN"] = "MAIN";
    ComponentType["DELIVERY_NOTE"] = "DELIVERY_NOTE";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
/**
 * Spůsob doručení
 */
var DispatchMethod;
(function (DispatchMethod) {
    DispatchMethod["EMAIL"] = "EMAIL";
    DispatchMethod["DATABOX"] = "DATABOX";
    DispatchMethod["POSTAL"] = "POSTAL";
    DispatchMethod["POSTAL_NOTE"] = "POSTAL_NOTE";
})(DispatchMethod = exports.DispatchMethod || (exports.DispatchMethod = {}));
//# sourceMappingURL=ess-types.js.map